import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Springfield Weed · Your Source for Cannabis News</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          Explore the latest updates on cannabis laws, policy changes, and cultural insights in Springfield. 
          Our mission is to provide comprehensive coverage and educational resources to keep you informed.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation affecting Springfield residents. 
            Our coverage includes analysis and implications of new laws.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Insights</h2>
          <p>
            Discover the evolving culture surrounding cannabis in our community. We provide articles and features 
            that highlight local events, advocacy efforts, and personal stories.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Access a wealth of information about cannabis, including its history, benefits, and responsible use. 
            Our guides are designed to educate and inform both newcomers and seasoned enthusiasts.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;